import { render, staticRenderFns } from "./FormatPropertyEditTool.vue?vue&type=template&id=4ba5b17e&scoped=true&"
import script from "./FormatPropertyEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatPropertyEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPropertyEditTool.vue?vue&type=style&index=0&id=4ba5b17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5b17e",
  null
  
)

export default component.exports